import React, { Component } from 'react';
import { Card, Modal } from "react-bootstrap";
import { FaPen, FaRegThumbsUp, FaRegThumbsDown, FaThumbsUp, FaThumbsDown } from "react-icons/fa6";
import { GetText, ReplacePrefixUrl, ReplaceText, ReplaceTextBr2Space } from '../../config/helper';
import DateTimeFormats from '../../config/date-time-format';
import PromptForm from './Form';
import PromptDetail from './Detail';

const authKey = global.config.kindcode.training[23]+global.config.authBearerKey;

export default class Block extends Component {
  constructor(props) {
    super(props);
    this.state = {
      memberId: localStorage.getItem('doc_id'),
      activePage: '',
      id: '',
      title: '',
      category: '',
      excerpt: '',
      image: '',
      link: '',
      likestatususer: '',
      likestatus: '',
      likestatusid: '',
      like: 0,
      dislike: 0,
      createbyid: '',
      createby: '',
      createon: '',
      data: {},
      modal_show_form: false,
      modal_show_detail: false,
    }
    this.urllikes = this.urllikes.bind(this);
  }
  handlePopOpen(name) {
    this.setState({ 
      [name]: true,
    });
  }
  handlePopClose(name) {
    this.setState({ 
      [name]: false,
    });
  }
  urllikes(id,nextstat,currstat,subid,user) {
    var currlike=Number(this.state.like); 
    var currdislike=Number(this.state.dislike);

    var datatext;
    var urlFetch = global.config.urlLink;
    if(currstat === "") {
      if(nextstat === global.config.likeStatus[0]) { currlike++; }
      else {  currdislike++; }
      datatext ='{"like_status":"'+nextstat+'","prompt_docid":"'+id+'","form_id":"form-like"}';
      urlFetch = urlFetch+"/promptadd";
      subid = "";
    } else { 
      if(currstat === nextstat) {
        if(nextstat === global.config.likeStatus[0]) { currlike--; }
        else {  currdislike--; }
        nextstat = "";
        datatext ='{"like_status":"'+nextstat+'","docid":"'+id+'","subdocid":"'+subid+'","form_id":"delete-prompt-like"}';
        urlFetch = urlFetch+"/promptdelete";
        subid = "";
      } else {
        if(user === this.state.memberId) {
          if(currstat === global.config.likeStatus[0]) { currlike--; currdislike++; }
          else {  currlike++; currdislike--; }
          datatext ='{"like_status":"'+nextstat+'","prompt_id":"'+id+'","promptlike_id":"'+subid+'","form_id":"form-like"}';
          urlFetch = urlFetch+"/promptedit";
  
        } else {
          if(nextstat === global.config.likeStatus[0]) { currlike++; }
          else {  currdislike++; }
          datatext ='{"like_status":"'+nextstat+'","prompt_docid":"'+id+'","form_id":"form-like"}';
          urlFetch = urlFetch+"/promptadd";
          subid = "";
        }
        
      }
    }
    
    var data = JSON.parse(datatext);
    fetch(urlFetch, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': authKey,
        }, body : JSON.stringify(data)
    }).then(res => {
        if(res.status === 200)
            return res.json() 
    }).then( resJson => {
        if(resJson.status === '200') {
          if(subid === "") { subid = resJson.values; }
          this.setState({
            likestatususer: this.state.memberId,
            likestatus: nextstat,
            likestatusid: subid,
            like: currlike,
            dislike: currdislike,
          });
         
        } else {
            console.log('Something happened wrong');
        }
       
    });
    
  }
  contentLikeIcons(likestat,like,dislike,createid,memberid,docid,subdocid,likestatuser) {
    var contentIcons = [];
    if(memberid === createid) {
      contentIcons.push(<>
        <FaPen className="style-action-icons" aria-label="edit" onClick={this.handlePopOpen.bind(this,"modal_show_form")} />  
        <FaRegThumbsUp className="style-action-icons-nolink" aria-label="like" /> {this.state.like}
        <FaRegThumbsDown className="style-action-icons-nolink" aria-label="dislike"  /> {this.state.dislike}
      </>)
    } else {
      if(likestat !== "" && likestat === global.config.likeStatus[0] && likestatuser === memberid) {
        contentIcons.push(<>
          <FaThumbsUp className="style-action-icons-on"  aria-label="like" onClick={this.urllikes.bind(this, docid,global.config.likeStatus[0],likestat,subdocid,likestatuser)} /> {like}
        </>)
      } else {
        contentIcons.push(<>
          <FaRegThumbsUp className="style-action-icons"  aria-label="like" onClick={this.urllikes.bind(this, docid,global.config.likeStatus[0],likestat,subdocid,likestatuser)} /> {like}
        </>)
      }

      if(likestat !== "" && likestat === global.config.likeStatus[1] && likestatuser === memberid) {
        contentIcons.push(<>
          <FaThumbsDown className="style-action-icons-on"  aria-label="like" onClick={this.urllikes.bind(this, docid,global.config.likeStatus[1],likestat,subdocid,likestatuser)} /> {dislike}
        </>)
      } else {
        contentIcons.push(<>
          <FaRegThumbsDown className="style-action-icons"  aria-label="like" onClick={this.urllikes.bind(this, docid,global.config.likeStatus[1],likestat,subdocid,likestatuser)} /> {dislike}
        </>)
      }
    }
    return contentIcons;
  }
  
  componentDidMount() {
    var content = this.props.value;
    this.setState({
      activePage: content.activePage,
      id: content.id,
      title: ReplaceText(content.promptSubject),
      category: content.promptCategoryName,
      excerpt: ReplaceTextBr2Space(content.promptDescription),
      likestatususer: content.likeStatusUser,
      likestatus: content.likeStatus,
      likestatusid: content.likeStatusId,
      like: content.numLike,
      dislike: content.numDislike,
      createbyid: content.createById,
      createby: content.createByName,
      createon: content.createDate !== undefined? DateTimeFormats(content.createDate._seconds,"datetime-short") : '',
      data: content,
    });
  }
  
  render() {   
    return (
      <div>
				<Card className="prompt-block">
					<Card.Body onClick={this.handlePopOpen.bind(this,"modal_show_detail")} className='text-link' >
						<Card.Title>{this.state.title}</Card.Title>
						<Card.Text>
							{this.state.excerpt}
						</Card.Text>
					</Card.Body>
          <Card.Footer className="text-muted">
            {this.contentLikeIcons(this.state.likestatus,this.state.like,this.state.dislike,this.state.createbyid,this.state.memberId,this.state.id,this.state.likestatusid,this.state.likestatususer)}
          </Card.Footer>
				</Card>

        <Modal animation={false} show={this.state.modal_show_form} size="lg" onHide={this.handlePopClose.bind(this,"modal_show_form")}>
          <Modal.Header closeButton>
            <Modal.Title>{GetText() ? "Edit prompt Anda" : "Edit your prompt"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <PromptForm value={{"currpage": this.state.activePage, "data": this.state.data}} />
          </Modal.Body>
        </Modal>

        <Modal animation={false} show={this.state.modal_show_detail} size="lg" onHide={this.handlePopClose.bind(this,"modal_show_detail")}>
          <Modal.Header closeButton>
            {/* <Modal.Title>{GetText() ? "Edit prompt Anda" : "Edit your prompt"}</Modal.Title> */}
          </Modal.Header>
          <Modal.Body>
            <PromptDetail value={{"currpage": this.state.activePage, "data": this.state.data, "type": "block"}} />
          </Modal.Body>
        </Modal>
			</div>
      
      
    )
  }
}